import { render, staticRenderFns } from "./MenuEdition.vue?vue&type=template&id=ae947a06&scoped=true&"
import script from "./MenuEdition.vue?vue&type=script&lang=js&"
export * from "./MenuEdition.vue?vue&type=script&lang=js&"
import style0 from "./MenuEdition.vue?vue&type=style&index=0&id=ae947a06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae947a06",
  null
  
)

export default component.exports